/* B.U.M. EQUIPMENT — Season 1 storefront.
   Header state, mega menu, variant selection, and an Ajax bag drawer
   wired to Shopify's Cart API (/cart/add.js, /cart.js, /cart/change.js). */

(function () {
  'use strict';

  var money = function (cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  };

  /* ----------------------------- header state ---------------------------- */
  var head = document.querySelector('.head');
  var hero = document.querySelector('.hero');

  function onScroll() {
    /* Past the announcement bar, it slides away and the header moves to top. */
    document.body.classList.toggle('scrolled', window.scrollY > 32);

    if (!head) return;
    /* Only a hero justifies a transparent header; without one it stays solid. */
    if (!hero) { head.classList.add('solid'); return; }
    head.classList.toggle('solid', window.scrollY > hero.offsetHeight - 80);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ------------------------------ mega menu ------------------------------ */
  var panels = document.querySelectorAll('.mega');

  function closeMenus() {
    panels.forEach(function (p) { p.classList.remove('open'); });
    onScroll();
  }

  document.querySelectorAll('[data-menu]').forEach(function (trigger) {
    var panel = document.getElementById(trigger.dataset.menu);
    if (!panel) return;
    function open() {
      closeMenus();
      panel.classList.add('open');
      if (head) head.classList.add('solid');
    }
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    panel.addEventListener('mouseleave', closeMenus);
  });

  document.addEventListener('mousemove', function (e) { if (e.clientY < 20) closeMenus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenus(); closeCart(); }
  });

  /* ------------------------------ bag drawer ----------------------------- */
  var scrim = document.querySelector('.scrim');
  var drawer = document.querySelector('.drawer');
  var body = document.querySelector('.drawer .db');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var totalEl = document.querySelector('[data-cart-total]');

  function openCart() {
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
  }

  function paint(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty lbl muted">Your bag is empty</p>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
        ? '<div class="vr">' + item.variant_title + ' · Qty ' + item.quantity + '</div>'
        : '<div class="vr">Qty ' + item.quantity + '</div>';
      return '<div class="line">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[^.]*)$/, '_200x$1') : '') + '" alt="">' +
          '<div>' +
            '<div class="nm">' + item.product_title + '</div>' +
            variant +
            '<a class="rm" href="#" data-remove-key="' + item.key + '">Remove</a>' +
          '</div>' +
          '<div class="pr">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function refresh(open) {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart); if (open) openCart(); return cart; });
  }

  function addVariant(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.data.description || 'Could not add that to the bag.'); return; }
        return refresh(true);
      });
  }

  function removeKey(key) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(paint);
  }

  /* --------------------------- variant selection ------------------------- */
  function syncVariant(form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;
    var chosen = [];
    form.querySelectorAll('.sizes').forEach(function (row) {
      var on = row.querySelector('button.on');
      chosen[+row.dataset.optionIndex] = on ? on.dataset.optionValue : null;
    });
    var wanted = chosen.filter(Boolean).join(' / ');
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.dataset.title === wanted) select.value = opt.value;
    });
  }

  /* -------------------------------- events ------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var rm = t.closest('[data-remove-key]');
    if (rm) { e.preventDefault(); removeKey(rm.dataset.removeKey); return; }

    if (t.closest('[data-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (t.closest('[data-cart-close]') || t.classList.contains('scrim')) { closeCart(); return; }

    var qa = t.closest('[data-quick-add]');
    if (qa && !qa.disabled) { e.preventDefault(); addVariant(qa.dataset.quickAdd, 1); return; }

    var sz = t.closest('.sizes button');
    if (sz && !sz.disabled) {
      sz.parentNode.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
      sz.classList.add('on');
      syncVariant(sz.closest('form'));
      return;
    }
  });

  var pform = document.getElementById('product-form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var select = pform.querySelector('[data-variant-select]');
      if (!select || !select.value) { alert('Select a size first.'); return; }
      addVariant(select.value, 1);
    });
  }

  refresh(false);
})();
